<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="rubric !== undefined" model="Rubric"></app-form-title>

	<app-text-field [fg]="form" formGroupOrControlName="code" label="Code"></app-text-field>

	<app-text-field [fg]="form" formGroupOrControlName="label" label="Label"></app-text-field>

	<app-number-field
		[fg]="form"
		formGroupOrControlName="display_order"
		label="Display Order"
		[min]="0"
	></app-number-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
